import { render, staticRenderFns } from "./UserTransactions.vue?vue&type=template&id=63646fb8&scoped=true&"
import script from "./UserTransactions.vue?vue&type=script&lang=js&"
export * from "./UserTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63646fb8",
  null
  
)

export default component.exports